import { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';

import { IConfigDashboard } from '../constants/dashboards';
import { periodoDoPreset } from '../utils/periodo';

// Corpo do POST /dashboard: chaves = laytel.cam; datas dd/mm/yyyy; checkbox '1'/'0'
export type Filtros = Record<string, string>;

export function filtrosPadrao(dash: IConfigDashboard): Filtros {
  const { ini, fim } = periodoDoPreset('mes');
  return { [dash.periodo.ini]: ini, [dash.periodo.fim]: fim };
}

// Últimos filtros usados em cada dashboard, por empresa/filial e navegador. Sem nada salvo: mês atual.
export default function useFiltrosDashboard(dash: IConfigDashboard) {
  const { cnpj, filial } = useParams();
  const chave = `sigepeweb::dashboard:${cnpj}:${(filial || 'MATRIZ').toUpperCase()}:${dash.id}`;

  const [filtros, setFiltros] = useState<Filtros>(() => {
    try {
      const texto = localStorage.getItem(chave);
      if (texto) return JSON.parse(texto) as Filtros;
    } catch {
      // localStorage bloqueado ou conteúdo inválido: usa o padrão
    }
    return filtrosPadrao(dash);
  });

  const salvar = useCallback((novos: Filtros) => {
    setFiltros(novos);
    try {
      localStorage.setItem(chave, JSON.stringify(novos));
    } catch {
      // sem localStorage o filtro vale só até recarregar a página
    }
  }, [chave]);

  return { filtros, salvar };
}
